import { render, staticRenderFns } from "./EditDressModal.vue?vue&type=template&id=11a91b8d&scoped=true"
import script from "./EditDressModal.vue?vue&type=script&lang=js"
export * from "./EditDressModal.vue?vue&type=script&lang=js"
import style0 from "./EditDressModal.vue?vue&type=style&index=0&id=11a91b8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a91b8d",
  null
  
)

export default component.exports